import { useCollection } from '../hooks/useCollection'
//styles
import './OnlineUsers.css'

export const OnlineUsers = () => {
    const{error,document} = useCollection('users')
  return (
    <div className='user-list'>
        <h2>All Users</h2>
        {error && <div className='error'>{error}</div>}
        {document && document.map((user) => (
            <div key={user.id} className='user-list-item'>
                {user.online && <span className='online-user'></span>}
                <span>{user.displayName}</span>
            </div>
        ))}
    </div>
  )
}
